<template>
    <table style="width:100%;" class="table b-table table-striped table-hover table-bordered table-sm b-table-fixed">
        <tr>
            <th rowspan="2" v-if="mode==='room'" style="width:30%">Программа</th>
            <th rowspan="2" v-if="mode==='program'" style="width:30%">Номер</th>
            <th rowspan="2" style="width:20%">Период</th>
            <th rowspan="2" style="width:15%">1-но местное размещение</th>
            <th colspan="2" style="width:15%">Взрослый</th>
            <template v-if="hotel.tarif_type1==1"><th colspan="2" style="width:15%">Дети от 0 до {{hotel.child_age1}}</th></template>
            <template v-if="hotel.tarif_type2==1"><th colspan="2" style="width:15%">Дети {{hotel.child_age1}} до {{hotel.child_age2}}</th></template>
            <template v-if="hotel.tarif_type3==1"><th colspan="2" style="width:15%">Дети {{hotel.child_age2}} до {{hotel.child_age3}}</th></template>
            <template v-if="hotel.tarif_type4==1"><th colspan="2" style="width:15%">Дети {{hotel.child_age3}} до {{hotel.child_age4}}</th></template>
            <template v-if="hotel.tarif_type5==1"><th colspan="2" style="width:15%">Дети {{hotel.child_age4}} до {{hotel.child_age5}}</th></template>
            <template v-if="hotel.tarif_type6==1"><th colspan="2" style="width:15%">Дети {{hotel.child_age5}} до 17</th></template>
        </tr>
        <tr>
            <th>осн.</th><th>доп.</th>
            <template v-if="hotel.tarif_type1==1"><th>осн.</th><th>доп.</th></template>
            <template v-if="hotel.tarif_type2==1"><th>осн.</th><th>доп.</th></template>
            <template v-if="hotel.tarif_type3==1"><th>осн.</th><th>доп.</th></template>
            <template v-if="hotel.tarif_type4==1"><th>осн.</th><th>доп.</th></template>
            <template v-if="hotel.tarif_type5==1"><th>осн.</th><th>доп.</th></template>
            <template v-if="hotel.tarif_type6==1"><th>осн.</th><th>доп.</th></template>
        </tr>
        <template v-for="price in filteredPrices">
            <tr :key="price.id+'-m'">
                <td v-if="mode==='room'">{{ price.program.title }}</td>
                <td v-if="mode==='program'">{{ price.room.title }}</td>
                <td>c {{ price.period.begin_at }} по {{ price.period.end_at }}</td>
                <td class="right">{{ formatPriceKop(price.pf01) }}</td>
                <td class="right">{{ formatPriceKop(price.pr00) }}</td>
                <td class="right">{{ formatPriceKop(price.pr01) }}</td>
                <template v-if="hotel.tarif_type1==1"><td class="right">{{ formatPriceKop(price.pr10) }}</td><td class="right">{{ formatPriceKop(price.pr11) }}</td></template>
                <template v-if="hotel.tarif_type2==1"><td class="right">{{ formatPriceKop(price.pr20) }}</td><td class="right">{{ formatPriceKop(price.pr21) }}</td></template>
                <template v-if="hotel.tarif_type3==1"><td class="right">{{ formatPriceKop(price.pr30) }}</td><td class="right">{{ formatPriceKop(price.pr31) }}</td></template>
                <template v-if="hotel.tarif_type4==1"><td class="right">{{ formatPriceKop(price.pr40) }}</td><td class="right">{{ formatPriceKop(price.pr41) }}</td></template>
                <template v-if="hotel.tarif_type5==1"><td class="right">{{ formatPriceKop(price.pr50) }}</td><td class="right">{{ formatPriceKop(price.pr51) }}</td></template>
                <template v-if="hotel.tarif_type6==1"><td class="right">{{ formatPriceKop(price.pr60) }}</td><td class="right">{{ formatPriceKop(price.pr61) }}</td></template>
            </tr>
        </template>
    </table>
</template>


<script>
    import { functions } from '@/functions';
    //import { functions_price } from '@/functions_price';

    export default {
        name: 'PricesTable',
        mixins: [functions],
        props: [
            'hotel',
            'prices',
            'filterroomid',
            'filterprogramid',
            'mode'
        ],
        data: function () {
            return {

            };
        },
        methods: {
            priceComparator: function(room_id, program_id) {
                return function(element) {
                    if (room_id) {
                        if (element.t_obj_rooms_id != room_id) {
                            return false;
                        }
                    }
                    if (program_id) {
                        if (element.t_obj_tariff_id != program_id) {
                            return false;
                        }
                    }
                    return true;
                }
            },
        },
        computed: {
            filteredPrices: function () {
                //console.log('filteredPrices('+this.filterroomid + ','+this.filterprogramid+')');
                return this.prices.filter(this.priceComparator(this.filterroomid, this.filterprogramid))
            },
        }
    }
</script>


<style>

</style>
